import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { FEATURE_FLAGS } from "../../../../constants/Define";
import CategoryList from './CategoryList';

let permisionActions = [];
class SupplierCategory extends Component {

    state = {
        filters: {
            pageSize: this.props.supplierCategoryState.pageSize,
            pageIndex: this.props.supplierCategoryState.pageIndex,
        }
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.SUPPLIER_CATEGORY);
        this.props.getSupplierCategoryList(this.state.filters);
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, supplierCategories } = this.props.supplierCategoryState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'category'}
                        titleHeader={t('navigation.category')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to={`/category/action`}
                                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <CategoryList loading={isFetching}
                        permisions={permisionActions}
                        supplierCategories={supplierCategories}
                        onDeleteSupplierCategory={this.onDeleteSupplierCategory}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onLockRateCode={this.lockRateCode}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getSupplierCategoryList(this.state.filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.getSupplierCategoryList(newFilters);
    };

    onDeleteSupplierCategory = (category) => {
        this.props.deleteSupplierCategoryAction(category, this.state.filters)
    }
}


export default SupplierCategory;
